document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach(function (item) {
    const question = item.querySelector(".faq-item-question");
    const answer = item.querySelector(".faq-answer");
    const icon = item.querySelector("svg");

    question.addEventListener("click", function () {
      faqItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          // Close other items
          otherItem.querySelector(".faq-answer").style.display = "none";
          otherItem.classList.remove("open");
          const otherIcon = otherItem.querySelector("svg");
          if (otherIcon) otherIcon.style.transform = "rotate(0deg)";
        }
      });

      if (answer.style.display === "block") {
        answer.style.display = "none";
        item.classList.remove("open");
        if (icon) icon.style.transform = "rotate(0deg)";
      } else {
        answer.style.display = "block";
        item.classList.add("open");
        if (icon) icon.style.transform = "rotate(180deg)";
      }
    });
  });
});
